import { Injectable } from '@angular/core';
import { SafariReduxPageUiObject, defaultPageUiState } from '@safarilaw-webapp/shared/redux';

import { createSelector } from '@ngrx/store';
import { getSharedFeatureState } from '../../../redux/state.selector';
import { IInboundEmailListPageUiState } from './interface';

@Injectable({ providedIn: 'root' })
export class LpmsInboundEmailsListPageReduxUiObject extends SafariReduxPageUiObject<IInboundEmailListPageUiState> {
  // Doing this to prevent the compiler from complaining. We will be getting rid of this default
  // thing but this makes it compile for now
  default = {};

  constructor() {
    const getPageState = createSelector(getSharedFeatureState, state => state.pages.intakeEmailEditPage);
    super('Lpms', 'Intake Email', getPageState, defaultPageUiState);
  }
}
